<template>
  <AppHeader />
  <div class="bg-gray-100 pt-8 pb-8 px-4">
    <div class="max-w-7xl mx-auto space-y-10">
      <!-- Header -->
      <div class="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <div class="flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          <div class="flex items-center space-x-4">
            <div class="relative">
              <img 
                :src="profile?.profilePicture || require('@/assets/defaultProfile.png')" 
                alt="Profile Picture"
                class="w-16 h-16 rounded-full border-2 border-white object-cover shadow-lg"
              />
              <router-link 
                to="/update-profile-picture"
                class="absolute bottom-0 right-0 bg-white p-1.5 rounded-full shadow-md hover:bg-primary-lighter transition-colors"
              >
                <span class="material-symbols-outlined text-sm text-primary">photo_camera</span>
              </router-link>
            </div>
            <div>
              <h1 class="text-2xl font-bold text-gray-800 text-left">{{ profile?.name }} {{ profile?.surname }}</h1>
              <p class="text-primary font-medium text-left">{{ profile?.email }}</p>
            </div>
          </div>
          <router-link
            to="/"
            class="inline-flex items-center gap-2 px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition-all duration-200 font-semibold shadow-sm hover:shadow-md transform hover:scale-105"
          >
            <span class="material-symbols-outlined text-xl">smart_display</span>
            Generate Video Ideas
          </router-link>
        </div>
      </div>

      <!-- Loading State -->
      <div v-if="loading" class="space-y-6">
        <div class="animate-pulse flex flex-col items-center">
          <div class="h-8 w-8 bg-primary-light rounded-full mb-4"></div>
          <div class="h-4 bg-primary-light rounded w-3/4 mb-2"></div>
          <div class="h-4 bg-primary-light rounded w-1/2"></div>
        </div>
      </div>

      <!-- Main Content -->
      <template v-else>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <!-- Personal Information Card -->
          <PersonalInformationCard :profile="profile" />

          <!-- Subscription Card -->
          <SubscriptionCard :profile="profile" />

          <!-- Usage Statistics Card -->
          <UsageStatisticsCard 
            :profile="profile" 
            :global-settings="globalSettings" 
          />

          <!-- Account Actions Card -->
          <AccountActionsCard 
            :loading="loading" 
            @logout="logout" 
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { logoutUser } from '@/composables/useAuth';
import AppHeader from '@/components/common/AppHeader.vue';
import PersonalInformationCard from '@/components/profile/PersonalInformationCard.vue';
import SubscriptionCard from '@/components/profile/SubscriptionCard.vue';
import UsageStatisticsCard from '@/components/profile/UsageStatisticsCard.vue';
import AccountActionsCard from '@/components/profile/AccountActionsCard.vue';

export default {
  components: { 
    AppHeader,
    PersonalInformationCard,
    SubscriptionCard,
    UsageStatisticsCard,
    AccountActionsCard
  },
  data() {
    return {
      showDeleteInput: false
    };
  },
  computed: {
    ...mapState(['user', 'profile', 'loading', 'globalSettings'])
  },
  methods: {
    async logout() {
      await logoutUser();
      this.$router.push('/login');
    }
  }
};
</script>

<style scoped>
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}
</style>
